import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'

/* Future expansion:
If the Third level navigation becomes sticky, a section observer o.Ä. can be used to check the current section and set the title active.
See 'Tabs.js' on how to set titles active. Add add 'underline-wrapper' to template, like in tabs. */

const ThirdLevelNavigation = el => {
  let titlesWidth = 0
  const prefix = el.dataset.prefix
  const titlesContainer = find('[data-titles]', el)
  const titlesInner = find('[data-inner-titles]', el)
  const indicatorBefore = find('[data-before]', el)
  const indicatorAfter = find('[data-after]', el)
  // const underline = find('[data-underline]', el)
  const underlineHover = find('[data-underline-hover]', el)

  const titles = findAll('[data-title]', el)

  if (titles && titles.length > 0) {
    underlineHover.style.width = 0
  }

  titles.forEach((title) => {
    if (!title.classList.contains(prefix + 'inactive')) {
      title.addEventListener('mouseover', () => {
        underlineHover.style.width = title.offsetWidth + 'px'
        underlineHover.style.transform = 'translate(' + title.offsetLeft + 'px,-4px)'
        underlineHover.style.opacity = 1
      })

      title.addEventListener('mouseout', () => {
        underlineHover.style.opacity = 0
      })
    }

    if (title.dataset.anchor === window.location.hash.split('#').find(h => h.includes('tab-'))) {
      title.click()
    }
  })

  const titleArray = Array.from(titlesInner.children)

  titleArray.forEach(child => {
    const style = child.currentStyle || window.getComputedStyle(child)
    titlesWidth += child.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
  })

  const widthDifference = titlesWidth - titlesInner.offsetWidth - 5

  if (titlesWidth > titlesInner.offsetWidth) {
    indicatorBefore.classList.add(prefix + 'has--indicators')
    indicatorAfter.classList.add(prefix + 'has--indicators')
    indicatorAfter.classList.add(prefix + 'is--visible')
  }

  titlesContainer.onscroll = function () {
    if (titlesContainer.scrollLeft > 5) {
      indicatorBefore.classList.add(prefix + 'is--visible')
    } else {
      indicatorBefore.classList.remove(prefix + 'is--visible')
    }

    if (titlesContainer.scrollLeft < widthDifference) {
      indicatorAfter.classList.add(prefix + 'is--visible')
    } else {
      indicatorAfter.classList.remove(prefix + 'is--visible')
    }
  }

  indicatorAfter.addEventListener('click', (e) => {
    scroll('right', e.target)
  })

  indicatorBefore.addEventListener('click', (e) => {
    scroll('left', e.target)
  })

  const scroll = (direction, target) => {
    target.classList.add(prefix + 'is--scrolling')
    const duration = 1000
    const start = titlesContainer.scrollLeft
    const change = (direction === 'right') ? titlesInner.offsetWidth : -titlesInner.offsetWidth
    let currentTime = 0
    const increment = 20

    const animateScroll = function () {
      currentTime += increment
      const val = Math.easeInOutQuad(currentTime, start, change, duration)
      titlesContainer.scrollLeft = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      } else {
        target.classList.remove(prefix + 'is--scrolling')
      }
    }
    animateScroll()
  }

  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
}

register('ThirdLevelNavigation', ThirdLevelNavigation)
